<template>
    <base-dropdown v-if="dropdownOpen">
        <template #dropdown-content>
            <div class="contacts-wrapper">
                <p class="content-title contacts-title">Artists from your contact list</p>
                <div
                    v-for="(contact, indx) in filteredContacts"
                    :key="indx"
                    @click="addContactEmail(contact)"
                    class="contact"
                >
                    <img :src="contact.avatar" class="contact-avatar" alt="contact-avatar" />
                    <span class="content-title contact-name">
                        {{ contact.band_name }}
                    </span>
                </div>
            </div>
        </template>
    </base-dropdown>
</template>
<script>
    import { useVenueContacts } from '@/composables/features/venue-booking/useVenueContacts'
    import BaseDropdown from '@/components/ui/dropdowns/BaseDropdown'

    export default {
        name: 'ContactsDropdown',
        components: {
            BaseDropdown
        },
        props: {
            showContacts: {
                required: true,
                type: Boolean
            },
            userInput: {
                required: false,
                type: String
            },
            contacts: {
                required: true,
                type: Array
            }
        },
        emits: ['selected-contact'],
        setup(props, context) {
            const { dropdownOpen, addContactEmail, filteredContacts } = useVenueContacts(
                props,
                context
            )

            return {
                dropdownOpen,
                addContactEmail,
                filteredContacts
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    p {
        margin-bottom: 0px;
    }
    .content-title {
        color: #8b8b8b;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .contacts-wrapper::-webkit-scrollbar {
        display: none;
    }
    .contacts-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 8px;
        overflow-y: scroll;
        max-height: 150px;
        max-width: 311px;
        -ms-overflow-style: none;
        scrollbar-width: none;

        .contacts-title {
            font-size: 16px;
            margin-top: 5px;
            color: #8b8b8b;
            font-family: 'Instrument Sans';
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px;
            letter-spacing: -0.16px;
            text-wrap: nowrap;
        }
        .contact {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            gap: 8px;
            cursor: pointer;

            .contact-avatar {
                width: 40px;
                height: 40px;
                object-fit: cover;
                border-radius: 50%;
            }
            .contact-name {
                font-size: 14px;
            }
        }
    }
</style>
